/**
 * Checks whether the account was created within the given grace window.
 *
 * @param createdAt - ISO-8601 creation timestamp from Okta.
 * @param gracePeriodMinutes - Number of minutes after creation to allow access.
 * @returns True if the current time is within the grace period.
 */
export function isWithinGracePeriod(createdAt, gracePeriodMinutes) {
    return remainingGracePeriodMs(createdAt, gracePeriodMinutes) > 0;
}
/**
 * Returns the number of milliseconds remaining before the grace period expires.
 *
 * @param createdAt - ISO-8601 creation timestamp from Okta.
 * @param gracePeriodMinutes - Number of minutes after creation to allow access.
 * @returns Remaining milliseconds (0 if already expired or invalid).
 */
export function remainingGracePeriodMs(createdAt, gracePeriodMinutes) {
    const created = new Date(createdAt).getTime();
    if (Number.isNaN(created))
        return 0;
    return Math.max(0, created + gracePeriodMinutes * 60 * 1000 - Date.now());
}
//# sourceMappingURL=index.js.map